/**
 * 年度建设数量走势组件
 * zxw
 * 2025-03-25
 */
import React, { useEffect, useState } from 'react';
import { Chart } from '@antv/g2';
import CNF from '../../incs/Config.js';

const TeiiIntersectionITYEC = (props) => {
    const [data, setData] = useState([]);

    useEffect(()=>{
        if (props.data) setData(props.data);
    }, [props]);

    useEffect(()=>{
        const chart = new Chart({
            container: props.container ? props.container : 'antv-g2-id',
            autoFit: props.isMobileDevice ? true : false,
        });

        chart.title({
            title: props.title,
            subtitle: props.subtitle,
        });

        chart.data(data);
          
        chart
            .encode('x', 'year')
            .encode('y', 'count')
            .scale('y', {
                domainMin: 0,
                nice: true,
                tickCount: 4,
            });

        chart.line()
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches.default,
            })
            .axis('x', { title: '年份', })
            .axis('y', { title: '', labelFormatter: (d) => (d) })
            .animate('enter', {
                type: 'pathIn',
                duration: 3000,
            },)
            .tooltip({
                items: [ 
                    { channel: 'y', name: '建设数量', valueFormatter: (d) => `${d}个`, }
                ],
            })
            .style('lineWidth', 1);

        chart.point().style('fill', '#fff').tooltip(false);

        chart.render();

        return ()=>{
            chart.destroy();
        }
    },[data]);
    
    return <div id='antv-g2-id'></div>;
}

export default TeiiIntersectionITYEC;